<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">
          Payment Pack - Send Email
        </h1>
      </template>
      <template #actions>
        <page-header-action
          v-if="hasAgent && !readonly"
          @click.prevent="sendEmailWithAgent"
        >
          Send and Instruct Agent to Recover
        </page-header-action>
        <page-header-action
          @click.prevent="sendEmailWithoutAgent"
          v-if="!readonly"
        >
          Send and Move to Recovery
        </page-header-action>
        <page-header-action @click.prevent="toggleNotes">
          Notes
        </page-header-action>
      </template>
    </page-header>
    <div class="row">
      <div class="col-12">
        <form-navigation-tabs
          :tabs="tabs"
          v-on:selected="setActive"
          :simple="true"
          :active="currentView"
        ></form-navigation-tabs>
      </div>
    </div>
    <div v-show="currentView == 'payment_pack'">
      <fieldset
        :disabled="readonly"
        style="border:0;padding:0;margin:0;min-width:0;"
      >
        <div class="row">
          <div class="col-lg-12">
            <div class="card mb-3">
              <div class="card-body">
                <div class="alert alert-info text-center">
                  <p class="mb-0">Please comma separate email addresses</p>
                </div>
                <inputbox
                  name="to"
                  label="To"
                  v-model="form.to"
                  :show-error="form.errors.has('to')"
                  :error-message="form.errors.get('to')"
                ></inputbox>
                <inputbox name="cc" label="CC" v-model="form.cc"></inputbox>
                <inputbox
                  name="subject"
                  label="Subject"
                  v-model="form.subject"
                  :show-error="form.errors.has('subject')"
                  :error-message="form.errors.get('subject')"
                ></inputbox>
                <input-block
                  name="body"
                  label="Message"
                  v-model="form.body"
                  :show-error="form.errors.has('body')"
                  :error-message="form.errors.get('body')"
                ></input-block>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="card mb-3">
              <div class="card-header">
                <h2 class="card-title">Attachments</h2>
                <button
                  class="btn btn-xs btn-primary"
                  v-on:click.prevent="openAddAttachmentModal"
                  v-if="!readonly"
                >
                  Add Attachment
                </button>
              </div>
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-bind:key="index"
                    v-for="(document, index) in form.documents"
                  >
                    <td v-text="document.type.label"></td>
                    <td>
                      <button
                        class="btn btn-primary btn-xs"
                        v-on:click.prevent="viewDocument(document)"
                      >
                        Preview
                      </button>
                      <button
                        class="btn btn-danger btn-xs"
                        v-on:click.prevent="detachDocument(document)"
                        v-if="!readonly"
                      >
                        Detach
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
    <incident-details
      :incident="incident"
      v-show="currentView == 'incident_details'"
    ></incident-details>
    <notes-window
      :show="notes"
      :incident="incident"
      v-on:toggle-note="toggleNotes"
    ></notes-window>

    <modal :show="modals.attachment" :large="true" :fire-event="false">
      <h4 slot="title">Add Attachment</h4>
      <div>
        <selectlist
          :options="availableDocuments"
          key-name="identifier"
          label="Attachment"
          label-name="type_label"
          v-model="selectedAttachment"
          name="attachment"
          placeholder="Please Select"
          :required="true"
          :show-error="showAttachmentError"
          error-message="You must select an attachment to add."
        >
          <div slot="rightBtn">
            <button
              class="btn btn-primary"
              :disabled="!selectedAttachment"
              v-on:click.prevent="previewChosenAttachment"
            >
              Preview
            </button>
          </div>
        </selectlist>
      </div>
      <div class="footer" slot="footer">
        <button
          class="btn btn-danger float-left"
          v-on:click.prevent="resetModalDetails"
        >
          Close
        </button>
        <button
          class="btn btn-primary"
          v-on:click.prevent="addAttachmentToList"
        >
          Attach File
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
import Notes from './../Shared/Notes.vue';
import IncidentDetails from './../Shared/IncidentDetails.vue';
import PageHeader from './../Shared/PageHeader.vue';
import PageHeaderAction from './../Shared/PageHeaderAction.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  components: {
    PageHeader,
    PageHeaderAction,
    'notes-window': Notes,
    'incident-details': IncidentDetails
  },

  data() {
    return {
      modals: {
        attachment: false
      },
      notes: false,
      currentView: 'payment_pack',
      tabs: [
        {
          name: 'payment_pack',
          label: 'Payment Pack - Send Email'
        },
        {
          name: 'incident_details',
          label: 'Incident Details'
        }
      ],
      form: new window.Form({
        to: null,
        cc: null,
        subject: 'Payment Pack',
        body:
          'Dear Sir/Madam, \n\nPlease find attached the payment pack documents for our client.',
        documents: []
      }),
      documents: [],
      selectedAttachment: null,
      showAttachmentError: false
    };
  },

  mounted() {
    this.getThirdParty();
    this.getDocuments();
  },

  computed: {
    readonly() {
      return this.isReadonly();
    },

    availableDocuments() {
      return this.documents.filter(document => {
        return (
          this.form.documents.findIndex(record => {
            return record.identifier === document.identifier;
          }) === -1
        );
      });
    },

    hasAgent() {
      return false;
      //                return !!this.$store.getters.agent;
    }
  },

  methods: {
    previewChosenAttachment() {
      if (this.selectedAttachment) {
        this.previewDocument(this.selectedAttachment);
      }
    },

    previewDocument(identifier) {
      window.open(
        `${window.AxisUK.api}incidents/${
          this.incident
        }/documents/${identifier}?token=${window.window.Token.get()}`,
        '_blank'
      );
    },

    resetModalDetails() {
      this.modals.attachment = false;
      this.selectedAttachment = null;
      this.showAttachmentError = false;
    },

    addAttachmentToList() {
      if (this.readonly) return;
      if (this.selectedAttachment) {
        let document = this.documents.find(record => {
          return record.identifier === this.selectedAttachment;
        });

        if (document) {
          this.form.documents.push(document);
          this.resetModalDetails();
        }
      } else {
        this.showAttachmentError = true;
      }
    },

    openAddAttachmentModal() {
      if (this.readonly) return;
      this.modals.attachment = true;
    },

    detachDocument(document) {
      if (this.readonly) return;
      window
        .swal({
          title: 'Are you sure?',
          text: `This will detach the ${document.type.label} from the payment pack email`,
          type: 'warning',
          showCancelButton: true
        })
        .then(() => {
          let index = this.form.documents.findIndex(record => {
            return record.identifier === document.identifier;
          });

          if (index > -1) {
            this.form.documents.splice(index, 1);
          }
        })
        .catch(error => {});
    },

    viewDocument(document) {
      this.previewDocument(document.identifier);
    },

    getDocuments() {
      window.Ajax.get(`/incidents/${this.incident}/documents`)
        .then(response => {
          this.documents = response.data;
          this.addPaymentPackDocuments();
        })
        .catch(error => {});
    },

    addPaymentPackDocuments() {
      this.addDocument('vehicle_hire_agreement');
      this.addDocument('request_for_payment');
      this.addDocument('hire_period_validation');
      this.addDocument('statement_of_charges');
    },

    addDocument(type) {
      let document = this.documents.find(document => {
        return document.type.name === type;
      });

      if (document) {
        this.form.documents.push(document);
      }
    },

    sendNewClaimsAdviceDocument() {
      this.form
        .post(`/new-claims-advice/${this.incident}/email`)
        .then(response => {
          this.proceedToHireMonitoring();
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'There was an issue, please try again'
          );
        });
    },

    getThirdParty() {
      window.Ajax.get(`/incidents/${this.incident}/third-parties`)
        .then(response => {
          if (
            response.data.length > 0 &&
            response.data[0].insurer &&
            response.data[0].insurer.email
          ) {
            this.form.to = response.data[0].insurer.email;
          }
        })
        .catch(error => {});
    },

    toggleNotes() {
      this.notes = !this.notes;
    },
    setActive(tab) {
      this.currentView = tab;
    },

    sendToRecovery() {
      window.Ajax.post(`/claim-monitoring/${this.incident}`)
        .then(response => {
          this.route('/recovery');
        })
        .catch(error => {});
    },

    instructAgent() {
      let agent = this.$store.getters.agent;

      window.Ajax.post(
        `/incidents/${this.incident}/instruct-agent/${agent.identifier}`
      )
        .then(response => {
          window.Ajax.post(`/claim-monitoring/${this.incident}`)
            .then(response => {
              window.toastify.success(
                'Success!',
                'The agent was instructed successfully!'
              );
              this.route('/recovery');
            })
            .catch(error => {
              window.toastify.error(
                'Error',
                "Sorry, we couldn't instruct the agent"
              );
            });
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            "Sorry, we couldn't instruct the agent"
          );
        });
    },

    sendEmail(agent = false) {
      if (this.readonly) return;
      this.form
        .post(`/claim-monitoring/${this.incident}/payment-pack`)
        .then(response => {
          if (agent) {
            this.instructAgent();
          } else {
            this.sendToRecovery();
          }
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error sending the email.'
          );
        });
    },

    sendEmailWithAgent() {
      this.form
        .post(`/claim-monitoring/${this.incident}/payment-pack`)
        .then(response => {
          this.instructAgent();
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error sending the email.'
          );
        });
    },

    sendEmailWithoutAgent() {
      this.form
        .post(`/claim-monitoring/${this.incident}/payment-pack`)
        .then(response => {
          this.sendToRecovery();
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error sending the email.'
          );
        });
    }
  }
};
</script>
